import React from "react";
import { NavLink } from "react-router-dom";
import { observer } from "mobx-react-lite";
import {
  CSidebar,
  CSidebarHeader,
  CSidebarNav,
  CNavItem,
  CNavLink,
  CNavGroup,
  CNavTitle,
} from "@coreui/react";
import sidebarStore from "../../store/SidebarStore";
import CIcon from "@coreui/icons-react";
import {
  cilWarning,
  cilPeople,
  cilSpeedometer,
  cilSettings,
  cilCalendar,
  cilChartPie,
  cilMoney,
  cilBalanceScale,
  cilList,
  cilGraph,
  cilRestaurant,
  cilChatBubble,
  cilLayers,
  cilSwapHorizontal,
  cilChartLine,
  cilCalculator,
  cilTag,
  cilFile,
} from "@coreui/icons";

const Sidebar = observer(() => {
  const closeSidebar = () => {
    sidebarStore.setShow(false);
  };
  return (
    <CSidebar
      className="border-end"
      unfoldable={false}
      visible={sidebarStore.show}
      position="fixed"
      overlaid
      onVisibleChange={(visible) => sidebarStore.setShow(visible)}
    >
      <CSidebarHeader className="border-bottom" />
      <CSidebarNav>
        <CNavTitle>Аналитика</CNavTitle>
        <CNavItem>
          <CNavLink as={NavLink} to="/dashboard" onClick={closeSidebar}>
            <CIcon customClassName="nav-icon" icon={cilSpeedometer} /> Dashboard
          </CNavLink>
        </CNavItem>
        <CNavItem>
          <CNavLink as={NavLink} to="/compare" onClick={closeSidebar}>
            <CIcon customClassName="nav-icon" icon={cilGraph} /> Сравнение периодов
          </CNavLink>
        </CNavItem>
        <CNavItem>
          <CNavLink as={NavLink} to="/groups" onClick={closeSidebar}>
            <CIcon customClassName="nav-icon" icon={cilList} /> Группы ресторанов
          </CNavLink>
        </CNavItem>

        <CNavTitle>Продажи</CNavTitle>
        <CNavItem>
          <CNavLink as={NavLink} to="/payment-types" onClick={closeSidebar}>
            <CIcon customClassName="nav-icon" icon={cilMoney} /> Типы оплат
          </CNavLink>
        </CNavItem>
        <CNavItem>
          <CNavLink as={NavLink} to="/categories" onClick={closeSidebar}>
            <CIcon customClassName="nav-icon" icon={cilChartPie} /> Категории
          </CNavLink>
        </CNavItem>
        <CNavItem>
          <CNavLink as={NavLink} to="/dish-stats" onClick={closeSidebar}>
            <CIcon customClassName="nav-icon" icon={cilRestaurant} /> Блюда
          </CNavLink>
        </CNavItem>
        <CNavItem>
          <CNavLink as={NavLink} to="/promotions" onClick={closeSidebar}>
            <CIcon customClassName="nav-icon" icon={cilTag} /> Акции и скидки
          </CNavLink>
        </CNavItem>

        <CNavTitle>Персонал</CNavTitle>
        <CNavItem>
          <CNavLink as={NavLink} to="/waiters" onClick={closeSidebar}>
            <CIcon customClassName="nav-icon" icon={cilPeople} /> Официанты
          </CNavLink>
        </CNavItem>

        <CNavGroup
          toggler={
            <>
              <CIcon customClassName="nav-icon" icon={cilBalanceScale} /> Контроль
            </>
          }
        >
          <CNavItem>
            <CNavLink as={NavLink} to="/ops-summary" onClick={closeSidebar}>
              <CIcon customClassName="nav-icon" icon={cilBalanceScale} /> Операционный контроль
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink as={NavLink} to="/dangerous-ops" onClick={closeSidebar}>
              <CIcon customClassName="nav-icon" icon={cilWarning} /> Опасные операции
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink as={NavLink} to="/cash-shifts" onClick={closeSidebar}>
              <CIcon customClassName="nav-icon" icon={cilCalendar} /> Кассовые смены
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink as={NavLink} to="/cash-analytics" onClick={closeSidebar}>
              <CIcon customClassName="nav-icon" icon={cilMoney} /> Кассовая аналитика
            </CNavLink>
          </CNavItem>
        </CNavGroup>

        <CNavTitle>Планирование</CNavTitle>
        <CNavItem>
          <CNavLink as={NavLink} to="/menu-engineering" onClick={closeSidebar}>
            <CIcon customClassName="nav-icon" icon={cilRestaurant} /> Меню-инжиниринг
          </CNavLink>
        </CNavItem>
        <CNavItem>
          <CNavLink as={NavLink} to="/warehouse" onClick={closeSidebar}>
            <CIcon customClassName="nav-icon" icon={cilLayers} /> Склад
          </CNavLink>
        </CNavItem>
        <CNavItem>
          <CNavLink as={NavLink} to="/sales-channels" onClick={closeSidebar}>
            <CIcon customClassName="nav-icon" icon={cilSwapHorizontal} /> Каналы продаж
          </CNavLink>
        </CNavItem>
        <CNavItem>
          <CNavLink as={NavLink} to="/forecast" onClick={closeSidebar}>
            <CIcon customClassName="nav-icon" icon={cilChartLine} /> Прогноз продаж
          </CNavLink>
        </CNavItem>
        <CNavItem>
          <CNavLink as={NavLink} to="/cost-margin" onClick={closeSidebar}>
            <CIcon customClassName="nav-icon" icon={cilCalculator} /> Себестоимость
          </CNavLink>
        </CNavItem>
        <CNavItem>
          <CNavLink as={NavLink} to="/compare-servers" onClick={closeSidebar}>
            <CIcon customClassName="nav-icon" icon={cilGraph} /> Сравнение точек
          </CNavLink>
        </CNavItem>
        <CNavItem>
          <CNavLink as={NavLink} to="/custom-reports" onClick={closeSidebar}>
            <CIcon customClassName="nav-icon" icon={cilFile} /> Отчёты iiko
          </CNavLink>
        </CNavItem>

        <CNavTitle>Помощник</CNavTitle>
        <CNavItem>
          <CNavLink as={NavLink} to="/assistant" onClick={closeSidebar}>
            <CIcon customClassName="nav-icon" icon={cilChatBubble} /> AI-помощник
          </CNavLink>
        </CNavItem>

        <CNavTitle>Настройки</CNavTitle>
        <CNavItem>
          <CNavLink as={NavLink} to="/settings" onClick={closeSidebar}>
            <CIcon customClassName="nav-icon" icon={cilSettings} /> Настройки
          </CNavLink>
        </CNavItem>
      </CSidebarNav>
    </CSidebar>
  );
});

export default Sidebar;
